export const formatLogin = login => {
    const pattern = /\d+/

    if (pattern.test(login)) {
        if (login.length == 11) {
            return login.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
        } else {
            return login.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
        }
    }

    return login
}



// WEBPACK FOOTER //
// ./src/helpers/login.js